<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-6.8 -7.5)">
      <path
        d="M12.712,11.418a.579.579,0,0,1,0,.83L9.906,15H20.618a.587.587,0,1,1,0,1.174H9.906l2.816,2.749a.583.583,0,0,1,0,.83.611.611,0,0,1-.848,0L8.053,16h0a.658.658,0,0,1-.125-.185.548.548,0,0,1-.046-.226.581.581,0,0,1,.171-.411l3.816-3.746A.6.6,0,0,1,12.712,11.418Z"
        fill="#74788d"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconArrowLeftLong',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>